<template>
  <div class="billing">
    <b-container fluid="md" class="pb-5 mt-4 col-8">
      <b-col>
      <h3 class="mb-4">Paramètres de facturation</h3>
        <b-row class="tools mb-4">
          <b-col>
            <LoginSelector @login="login => { this.login = login }"/>
          </b-col>
        </b-row>
        <b-row v-if="login">
          <b-col>
              <b-form @submit="setBillingSettings">
                <b-form-checkbox class="mb-3" v-model="invoiceActivated">Facturation mensuelle</b-form-checkbox>
                <b-form-group label="Type de facturation :"  v-if="invoiceActivated">
                  <b-form-radio-group
                    label="Type de facturation"
                    id="billing-type"
                    v-model="billingTimeType"
                    :options="billingTimeTypeOptions"
                    name="billing-type"
                  ></b-form-radio-group>
                </b-form-group>
                <b-button class="mt-5" type="submit" variant="primary" block>Enregistrer les paramètres de facturation</b-button>
              </b-form>
          </b-col>
        </b-row>
      </b-col>
    </b-container>
  </div>
</template>

<script>
import LoginSelector from "@/components/LoginSelector.vue";
import GCMV2Chart from "@/components/charts/gcmv2/gcmv2Chart.vue";
import dayjs from "dayjs";

export default {
  name: 'Billing',
  components: {
    LoginSelector,
  },
  data: () => ({
    name: "Billing",
    login: null,
    loading: true,
    invoiceActivated: 0,
    billingTimeType: 1,
    billingTimeTypeOptions: [
      { text: 'E-commerce', value: 1 },
      { text: 'Hôtel', value: 2 },
    ]
  }),
  computed: {
    isLoading: function () {
      return this.$store.getters.isLoading;
    }
  },
  watch: {
    login: {
      handler: async function () {
        await this.getBillingSettings();
      },
      deep: true
    }
  },
  methods: {
    async getBillingSettings() {
      if (!this.login || this.login === 'Aucun') return;
      this.$store.commit("isLoading", true);
      try {
        const response = await this.$http.get(`/billing/${this.login}`);
        const {content} = response.data || {};
        if (content) {
          const {invoiceActivated, billingTimeType} = content;
          this.invoiceActivated = content[0].invoiceActivated === 1 ? true : false;
          this.billingTimeType = content[0].billingType;
        }
      } catch (_) {
        console.warn('Cannot retrieve data');
      }
      this.$store.commit("isLoading", false);
    },
    setBillingSettings() {
      if (!this.login || this.login === 'Aucun') return;
      this.$store.commit("isLoading", true);
      try {
        const body = {
          invoiceActivated: this.invoiceActivated ? 1 : 0,
          billingTimeType: this.billingTimeType
        }
        this.$http.put(`/billing/${this.login}`, body)
          .then((response) => {
            this.$bvToast.toast('Paramètres de facturation enregistrés', {
              title: null,
              noCloseButton: true,
              variant: 'success',
              solid: true
            })
          })
          .catch(() => {
            this.$bvToast.toast("Bad Request, check form data", {
              title: "Error when updating billing settings",
              variant: 'danger',
              solid: true
            })
          });
      } catch (_) {
        console.warn('Cannot retrieve data');
      }
      this.$store.commit("isLoading", false);
    }
  },
}
</script>

<style lang="scss">

</style>
